export const COST_REDUCTION_CATEGORIES = [{
  value: 'ClaimGroup',
  label: 'Claim Group'
}, {
  value: 'UkSection::SubsidiaryCompany',
  label: 'Entity'
}, {
  value: 'BusinessUnit',
  label: 'Business Unit'
}, {
  value: 'CommercialProject',
  label: 'Commercial Project'
}, {
  value: 'ClaimProjectReport',
  label: 'Project'
}];